<template>
  <div class="container-fluid client min-vh-100 client-bids">
    <div class="clientWrap">
      <div class="row">
        <div class="col-md-12 py-4 text-left">
          <div class="d-flex justify-content-between align-items-center">
            <h1 v-if="isClient" id="v-step-0">My Filters</h1>
            <h1 v-else>Available Filters</h1>
            <button class="btn btn-icn ms-auto" @click="openAddFilterModal">
              <i class="fa fa-plus"></i> Create New Filter
            </button>
          </div>
        </div>
      </div>
      <div class="row">
         <div class="col-md-12">
        <div class="dark-filter w-100 p-1 mb-2 d-inline-block">
          <div class="d-flex justify-content-between align-items-center">
            <h5 class="ml-3 m-0">Filters</h5>
            <span class="btn btn-link" @click="showFilters = !showFilters">
              <i
                class="fa"
                v-bind:class="[showFilters ? 'fa-angle-up' : 'fa-angle-down']"
              ></i>
              {{ showFilters ? 'Hide' : 'Show' }} Filters
            </span>
          </div>
          <div class="row p-4" v-if="showFilters">
            <div class="col-lg-12">
              <form class="row">
             
                 <div class="col-md-6 col-lg-3" v-if="isRep || isAdmin">
                  <label for="filter" class="">User</label>
                     <multiselect
                          v-model="selectClient"
                          placeholder="Select"
                          :options="clientList"
                          :multiple="false"
                          label="clientFullName"
                          @input="onClientSelect"
                          track-by="id"
                        ></multiselect>
                </div>
                 <div class="col-md-6 col-lg-3" v-if="isAdmin" >
                  <label for="filter" class="">Representative</label>
                     <multiselect
                          v-model="selectRep"
                          placeholder="Select"
                          :options="repList"
                          :multiple="false"
                          label="repFullName"
                          @input="onRepSelect"
                          track-by="id"
                        ></multiselect>
                </div>
                   <div class="col-md-6 col-lg-3">
                  <label for="filter" class="">Filter Name</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="searchValue"
                    placeholder="Enter Filter Name"
                  />
                </div>
                <div class="col-md-6 col-lg-3 mt-2">
                  <button
                    @click="clear()"
                    type="button"
                    class="btn btn-secondary rounded mt-4"
                  >
                    Clear
                  </button>
                  <button
                    @click="search()"
                    type="button"
                    class="btn btn-primary rounded mt-4"
                  >
                    Filter
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="history filter-list">
            <div class="table-responsive p-0">
              <table class="table table-striped table-hover">
                <thead>
                  <tr>
                    <th
                      scope="col"
                      class="sort text-left"
                      v-bind:class="[
                      sortOrder == 'ASC' && sortColumn == 'name'
                        ? 'sort-client-asc'
                        : '',
                      sortOrder == 'DESC' && sortColumn == 'name'
                        ? 'sort-client-desc'
                        : '',
                      ]"
                      @click="sort('name')"
                    >
                      Filter Name
                    </th>
                    <th 
                      scope="col"  
                      class="sort text-left"
                      v-bind:class="[
                      sortOrder == 'ASC' && sortColumn == 'clientFirstName'
                        ? 'sort-client-asc'
                        : '',
                      sortOrder == 'DESC' && sortColumn == 'clientFirstName'
                        ? 'sort-client-desc'
                        : '',
                      ]"
                      @click="sort('clientFirstName')"
                      v-if="!isClient">
                      User
                    </th>
                     <th 
                      scope="col" 
                      class="sort text-left"
                      v-bind:class="[
                      sortOrder == 'ASC' && sortColumn == 'clientRepFirstName'
                        ? 'sort-client-asc'
                        : '',
                      sortOrder == 'DESC' && sortColumn == 'clientRepFirstName'
                        ? 'sort-client-desc'
                        : '',
                      ]"
                      @click="sort('clientRepFirstName')"
                      v-if="isAdmin">
                      Representative
                    </th>
                    <th 
                      scope="col" 
                      class="sort text-left"
                      v-bind:class="[
                      sortOrder == 'ASC' && sortColumn == 'todayHitCount'
                        ? 'sort-client-asc'
                        : '',
                      sortOrder == 'DESC' && sortColumn == 'todayHitCount'
                        ? 'sort-client-desc'
                        : '',
                      ]"
                      @click="sort('todayHitCount')" 
                      v-if="!isClient">
                      today's hit 
                    </th>
                    <th 
                    scope="col"
                     class="sort text-left"
                      v-bind:class="[
                      sortOrder == 'ASC' && sortColumn == 'totalHitCount'
                        ? 'sort-client-asc'
                        : '',
                      sortOrder == 'DESC' && sortColumn == 'totalHitCount'
                        ? 'sort-client-desc'
                        : '',
                      ]"
                      @click="sort('totalHitCount')"  v-if="!isClient">
                      total hit 
                    </th>
                    <th scope="col" class=" text-left" v-if="!isSearchOnly" id="v-step-1">
                      Filter Off/On
                    </th>
                    <th scope="col" class=" text-left" v-if="!isSearchOnly" id="v-step-2">
                      Email Alerts
                    </th>
                    <th scope="col" class=" text-left" v-if="!isSearchOnly" id="v-step-3">
            
                     Popup Alerts
                       <span class="hint cursor-pointer" data-toggle="tooltip" data-placement="right"  title="Pop Up Alerts will only be displayed during an active login session.">
                          <i class="fa fa-info-circle info-i " style="color: #027fc5"></i> </span>
                    </th>
                    <th scope="col" class=" text-left" v-if="!isSearchOnly && !isClient">
                    Internal email alerts
                    </th>
                    <th scope="col" class=" text-left" v-if="!isSearchOnly && !isClient">
                    Internal popup alerts
                    </th>
                    
                    <th scope="col" class=" text-center" id="v-step-4">Action</th>
                  </tr>
                </thead>
                <tbody class="list no-cursor">
                  <div class="loader" v-if="loading"></div>

                  <tr v-if="savedFilters.length == 0 && !loading">
                    <td><p class="nodata text-white">No data available</p></td>
                  </tr>

                  <tr v-for="data in savedFilters" :key="data.id">
                    <td class="text-left "><span class="client-name">{{ data.name }}</span> </td>
                   
                    <td class="text-left" v-if="!isClient">
                      {{ data.clientFirstName }} {{ data.clientLastName }}
                    </td>
                      <td class="text-left" v-if="isAdmin">
                      {{ data.clientRepFirstName }} {{ data.clientRepLastName }}
                    </td>
                     <td class="text-left "  v-if="!isClient"><span class="client-name">{{ data.todayHitCount }}</span> </td>
                    <td class="text-left "  v-if="!isClient"><span class="client-name">{{ data.totalHitCount }}</span> </td>
                    <td class="text-left" v-if="!isSearchOnly">
                      <toggle-button
                        :sync="true"
                        v-model="data.enable"
                        @change="onChangeEventHandler(data)"
                        :color="{ checked: '#0085CC', unchecked: '#000203' }"
                      />
                    </td>
                    <td class="text-left" v-if="!isSearchOnly">
                      <toggle-button
                        :sync="true"
                        v-model="data.shouldEmailNotify"
                        @change="onChangeEventHandler(data)"
                        :color="{ checked: '#0085CC', unchecked: '#000203' }"
                      />
                    </td>
                    <td class="text-left" v-if="!isSearchOnly">
                      <toggle-button
                        :sync="true"
                        v-model="data.shouldPushNotify"
                        @change="onChangeEventHandler(data)"
                        :color="{ checked: '#0085CC', unchecked: '#000203' }"
                      />
                    </td>
                    <td class="text-left" v-if="!isSearchOnly && !isClient">
                      <toggle-button
                        :sync="true"
                        v-model="data.shouldAdminEmailNotify"
                        @change="onChangeEventHandler(data)"
                        :color="{ checked: '#0085CC', unchecked: '#000203' }"
                      />
                    </td>
                    <td class="text-left" v-if="!isSearchOnly && !isClient">
                      <toggle-button
                        :sync="true"
                        v-model="data.shouldAdminPushNotify"
                        @change="onChangeEventHandler(data)"
                        :color="{ checked: '#0085CC', unchecked: '#000203' }"
                      />
                    </td>
                    <td class="text-center">
                      <button
                        :disabled="data.isPortfolio"
                        @click="editFilter(data)"
                        class="btn btn-primary"
                        type="button"
                        data-toggle="tooltip"
                        title="Edit Filter"
                      >
                        <i class="fas fa-pencil-alt"></i>
                      </button>
                      <button
                        :disabled="data.isPortfolio"
                        @click="deleteFilter(data)"
                        class="btn btn-danger"
                        type="button"
                        data-toggle="tooltip"
                        title="Delete Filter"
                      >
                        <i class="fas fa-trash"></i>
                      </button>
                      <button
                        :disabled="data.isPortfolio"
                        @click="duplicateFilter(data)"
                        class="btn btn-info"
                        type="button"
                        data-toggle="tooltip"
                        title="Duplicate Filter"
                      >
                        <i class="fas fa-clone"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="d-flex align-items-center mt-4 position-relative">
              <div class="d-flex align-items-center pagination-wrap">
              <b-pagination
                class="mt-4"
                :total-rows="totalRows"
                v-model="currentPage"
                :per-page="perPage"
                @input="getSavedFilters(currentPage)"
              ></b-pagination>
              <span class="ml-2 total-records-client">{{ currentPage }} of {{ totalPageSize }} pages</span>
              </div>
              <div class="total-records-client ml-auto">
                <span>Total Records : {{ totalRows }}</span>
              </div>
            </div>
            <!-- <nav aria-label="Page navigation example">
                <ul class="pagination justify-content-center">
                  <li class="page-item">
                    <a class="page-link" href="#" aria-label="Previous">
                      <span aria-hidden="true">&laquo;</span>
                    </a>
                  </li>
                  <li class="page-item"><a class="page-link" href="#">1</a></li>
                  <li class="page-item"><a class="page-link" href="#">2</a></li>
                  <li class="page-item"><a class="page-link" href="#">3</a></li>
                  <li class="page-item">
                    <a class="page-link" href="#" aria-label="Next">
                      <span aria-hidden="true">&raquo;</span>
                    </a>
                  </li>
                </ul>
              </nav> -->
          </div>
        </div>
      </div>
    </div>

    <AddEditFilter
      v-if="showAddFilterModal"
      @close="closeAddFilterModal"
      v-bind:selectedfilter="selectedFilter"
    />
    <v-tour name="FilterTour" :steps="steps" :options="myOptions" :callbacks="myCallbacks"></v-tour>
  </div>
</template>

<script>
import config from '@/config'
import authService from '@/authService'
import AddEditFilter from '@/components/client/AddEditFilter.vue'
export default {
  name: 'ClientFilter',
  components: {
    AddEditFilter
  },
  data () {
    return {
      loading: false,
      currentPage: 1,
      perPage: 25,
      searchValue: '',
      totalRows: 0,
      sortColumn: 'id',
      sortOrder: 'DESC',
      savedFilters: [],
      status: 'ACTIVE,INACTIVE',
      showAddFilterModal: false,
      selectedFilter: null,
      isSearchOnly: false,
      isToggle: true,
      isClient: false,
      isRep: false,
      showFilters: false,
      isAdmin: false,
      clientList: [],
      selectClient: '',
      totalPageSize: 0,
      repList: [],
      selectRep: '',

      steps: [
          {
            target: '#v-step-0',  // We're using document.querySelector() under the hood
            content: ` Displays all filters you have created.`,
            params: {
              enableScrolling: false
            }
          },
          {
            target: '#v-step-1',  // We're using document.querySelector() under the hood
            content: ` Filters are active by default upon creation. You can temporarily deactivate a filter by toggling the switch.`,
            params: {
              enableScrolling: false
            }
          },
          {
            target: '#v-step-2',  // We're using document.querySelector() under the hood
            content: ` Toggle this option to receive email notifications when a CUSIP matches your filter.`,
            params: {
              enableScrolling: false
            }
          },
          {
            target: '#v-step-3',  // We're using document.querySelector() under the hood
            content: ` Toggle this option to receive pop-up notifications when a CUSIP matches your filter while you are logged in.`,
            params: {
              enableScrolling: false
            }
          },
          {
            target: '#v-step-4',  // We're using document.querySelector() under the hood
            content: `Use the action menu to Update, Duplicate, or Delete a filter if it is no longer required.`,
            params: {
              enableScrolling: false
            }
          },
        ],
        myCallbacks: {
          onFinish: () => {
           localStorage.setItem('client_tour_completed_filter', 'true');
           this.$router.push("/client/portfolio")
          },
          onSkip: () => {
            localStorage.setItem('client_tour_completed_filter', 'true');
          }
        },
        myOptions: {
          enableScrolling: false,
          labels: {
            buttonSkip: 'Skip tour',
            buttonPrevious: 'Previous',
            buttonNext: 'Next',
            buttonStop: 'Next'
          }
        },
    }
  },
  methods: {
     sort(column) {
      this.sortColumn = column;
      this.sortOrder =
        this.sortOrder == "ASC"
          ? (this.sortOrder = "DESC")
          : (this.sortOrder = "ASC");
      this.getSavedFilters();
    },
     onChangeEventHandler(filter){
          this.loading = true;
          const auth = {
              headers: { 'org-token' : authService.getOrgToken()  }
          };
          let addData = {
            "filterId":filter.id,
            "status": filter.enable ? "ACTIVE" : "INACTIVE",
            "shouldEmailNotify": filter.shouldEmailNotify ? true : false,
            "shouldPushNotify": filter.shouldPushNotify ? true : false,
            "shouldAdminEmailNotify": filter.shouldAdminEmailNotify ? true : false,
            "shouldAdminPushNotify": filter.shouldAdminPushNotify ? true : false,
          }
          this.$http
          .put(config.baseUrlAutoBidder + "/offering-feed/filter-update-status",addData,auth)
          .then(() => {
          
           
          }).finally(() => {
            this.loading = false; 
            this.getSavedFilters();

          })
          .catch(() => {
              this.loading = false;              
          });

    },
    getRep() {
      const auth = {
        headers: { "org-token": authService.getOrgToken() },
      };
      let url = config.baseUrlBidSide + "/user/list?page=1&size=1000&search=&status=ACTIVE&sortColumn=firstName&sortOrder=ASC&group=Drl-Rep";
      
      this.$http
        .get(
          url,
          auth
        )
        .then((result) => {
          this.repList = result.data.content.map((rep) => {
            return {
              id: rep.id,
              repFullName: rep.firstName + " " + rep.lastName,
            };
          });
        })
        .catch((e) => {
          console.log(e);
          this.loading = false;
        });

    },
    getClients() {
      const auth = {
        headers: { "org-token": authService.getOrgToken() },
      };
      let url = "";
      if(this.isRep && !this.isAdmin){
        url = config.baseUrlAutoBidder + "/user/client-list?page=1&size=1000&search=&status=ACTIVE&sortColumn=firstName&sortOrder=ASC&clientRepId=" + authService.getUser().id;
      } else {
        url = config.baseUrlBidSide + "/user/list?page=1&size=1000&search=&status=ACTIVE&sortColumn=firstName&sortOrder=ASC&group=Drl-Client";
      }
      this.$http
        .get(
          url,
          auth
        )
        .then((result) => {
          this.clientList = result.data.content.map((client) => {
            return {
              id: client.id,
              clientFullName: client.firstName + " " + client.lastName,
            };
          });
        })
        .catch((e) => {
          console.log(e);
          this.loading = false;
        });
    },
    clear () {
      this.searchValue = ''
      this.selectClient = ''
      this.currentPage = 1
      this.totalPageSize = 0;
       this.selectRep = ''
      this.getSavedFilters()
    },
    duplicateFilter (filter) {
      // Create a copy of the filter object without the 'id' field
      const filterCopy = { ...filter }

      filterCopy.isDuplicate = true
      // Assign the modified copy to the selectedFilter
      this.selectedFilter = filterCopy

      // Toggle the modal
      this.showAddFilterModal = !this.showAddFilterModal
    },
    deleteFilter (filter) {
      var message = 'Are you sure you want to delete?'
      this.$confirm(message, '', 'question', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'
      }).then(() => {
        this.loading = true
        const auth = {
          headers: { 'org-token': authService.getOrgToken() }
        }
        let addData = {
          filterId: filter.id,
          status: 'DELETED',
          shouldEmailNotify: filter.shouldEmailNotify ? true : false,
          shouldPushNotify: filter.shouldPushNotify ? true : false
        }
        this.$http
          .put(
            config.baseUrlAutoBidder + '/offering-feed/filter-update-status',
            addData,
            auth
          )
          .then(() => {
            this.loading = false
            this.getSavedFilters()
          })
          .catch(() => {
            this.loading = false
          })
      })
    },
    editFilter (filter) {
      this.selectedFilter = filter
      this.showAddFilterModal = !this.showAddFilterModal
    },
    openAddFilterModal () {
      this.selectedFilter = null;
      this.showAddFilterModal = true
    },
    closeAddFilterModal () {
      this.showAddFilterModal = false
      this.getSavedFilters()
    },
    search () {
      this.currentPage = 1
      this.getSavedFilters()
    },
    getSavedFilters () {
      this.loading = true
      const auth = {
        headers: { 'org-token': authService.getOrgToken() }
      }
      let autoBidType = this.isSearchOnly ? 'SEARCH' : 'FILTER'
      let userId = '';
      if (this.isClient && !this.isAdmin) {
        userId = authService.getUser().id
      }
      if(this.selectClient){
        userId = this.selectClient.id
      }
      let repId = ""
      if(this.selectRep){
        repId = this.selectRep.id
      }
      if(this.isRep && !this.isAdmin){
        repId = authService.getUser().id
      }
      this.$http
        .get(
          config.baseUrlAutoBidder +
            '/offering-feed/filter-listall?page=' +
            this.currentPage +
            '&size=' +
            this.perPage +
            '&search=' +
            this.searchValue +
            '&status=' +
            this.status +
            '&sortColumn=' +
            this.sortColumn +
            '&sortOrder=' +
            this.sortOrder +
            '&userId=' +
            userId +
            '&isForClient=true' +
            '&filterType=' +
            autoBidType+
            '&clientRepId='+
             repId,

          auth
        )
        .then(result => {
          this.totalRows      = result.data.pageInfo.totalElements
          this.totalPageSize  = result.data.pageInfo.totalPageSize
          result.data.content.forEach(element => {
            if (element.status == 'ACTIVE') {
              element.enable = true
            } else {
              element.enable = false
            }
          })
          this.savedFilters = result.data.content
          this.loading = false
        })
        .catch(() => (this.loading = false))
    }
  },
  mounted () {
    this.$cognitoAuth.getUserGroup((err, role) => {
      if (err) {
        console.log('accessToken is not found', err)
      } else {
        this.tenantName = role[0].split('-')[0]
        var roleArray = role.map(item => {
          return item.split('-')[1]
        })
        roleArray.includes('Rep') ? (this.isRep = true) : (this.isRep = false)
        roleArray.includes('Admin') ? (this.isAdmin = true) : (this.isAdmin = false)
        roleArray.includes('Client') ? (this.isClient = true) : (this.isClient = false)
        if(this.isRep || this.isAdmin){
          this.getClients();
          this.getRep();
        }
        this.getSavedFilters()
      }
    })
    
    if(!localStorage.getItem('client_tour_completed_filter') && this.isClient){
      this.$tours['FilterTour'].start()
    }
    
  }
}
</script>
<style scoped>
.loader {
  width: 48px;
  height: 48px;
  border: 4px solid rgba(255, 255, 255, 0.1);
  border-top-color: #4c6fff; /* soft neon blue */
  border-radius: 50%;
  animation: spin 0.9s linear infinite;
  margin: auto;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
